import flatpickr, { flatpickrLocale } from "../flatpickr"
import BaseFilter from "./base_filter"
import { createElement, createFormGroup, createSummary } from "./dom"

const pad = (value) => String(value).padStart(2, "0")

const dateParts = (date) => {
  if (typeof date === "string") {
    const match = date.match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (match) { return { day: match[3], month: match[2], year: match[1] } }

    date = new Date(date)
  }

  if (!(date instanceof Date) || Number.isNaN(date.getTime())) { return null }

  return {
    day: pad(date.getDate()),
    month: pad(date.getMonth() + 1),
    year: date.getFullYear(),
  }
}

export const serializeDate = (date) => {
  const parts = dateParts(date)
  return parts ? `${parts.year}-${parts.month}-${parts.day}` : null
}

export const prettyDate = (date) => {
  const parts = dateParts(date)
  return parts ? `${parts.day}.${parts.month}.${parts.year}` : ""
}

export default class DateRangeFilter extends BaseFilter {
  createForm() {
    super.createForm()

    this.input = createElement("input", { className: "form-control is--hidden" })
    this.input.type = "text"
    this.element.append(createFormGroup(this.definition.title, this.input))
    this.appendApplyButton()

    return this.element
  }

  connect() {
    this.selectedDates = []
    this.picker = flatpickr(this.input, {
      mode: "range",
      inline: true,
      altFormat: "Y-m-d",
      dateFormat: "Y-m-d",
      locale: flatpickrLocale(this.context.locale),
      onChange: (selectedDates) => { this.selectedDates = selectedDates },
    })
  }

  disconnect() { this.picker?.destroy() }

  read() { return this.result(this.selectedDates, this.selectedDates.length === 2) }

  serialize(value) { return value.map(serializeDate) }

  summary(value) {
    if (!Array.isArray(value) || value.length !== 2) { return super.summary("") }
    return createSummary(this.definition.title, `${prettyDate(value[0])} - ${prettyDate(value[1])}`)
  }
}
